import { render, staticRenderFns } from "./VerticalNavMenuLink.vue?vue&type=template&id=28160f0d&scoped=true&"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuLink.vue?vue&type=style&index=0&id=28160f0d&prod&lang=css&"
import style1 from "./VerticalNavMenuLink.vue?vue&type=style&index=1&id=28160f0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28160f0d",
  null
  
)

export default component.exports